var _circle, _path, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpirence3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 56,
    fill: "url(#paint0_angular_22302_13261)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 60.5H63.5C62.7046 60.5008 61.942 60.8171 61.3796 61.3796C60.8171 61.942 60.5008 62.7046 60.5 63.5V96.5C60.5009 97.2954 60.8173 98.0579 61.3797 98.6203C61.9421 99.1827 62.7046 99.4991 63.5 99.5H96.5C97.2953 99.4989 98.0578 99.1825 98.6201 98.6201C99.1825 98.0578 99.4989 97.2953 99.5 96.5V63.5C99.4991 62.7046 99.1827 61.9421 98.6203 61.3797C98.0579 60.8173 97.2954 60.5009 96.5 60.5ZM96.5 69.5H81.5V63.5H96.5V69.5ZM78.5 96.5H72.5V90.5H78.5V96.5ZM78.5 87.5H72.5V81.5H78.5V87.5ZM69.5 87.5H63.5V81.5H69.5V87.5ZM72.5 78.5V72.5H87.5V78.5H72.5ZM72.5 69.5V63.5H78.5V69.5H72.5ZM90.5 72.5H96.5V78.5H90.5V72.5ZM69.5 63.5V78.5H63.5V63.5H69.5ZM63.5 90.5H69.5V96.5H63.5V90.5ZM81.5 96.5V81.5H96.5015L96.503 96.5H81.5Z",
    fill: "#7A5204"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 158,
    height: 158,
    rx: 79,
    stroke: "#FFC107",
    strokeOpacity: 0.24,
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_22302_13261",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80 80) rotate(-90) scale(56)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC81A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE475"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpirence3);
export default __webpack_public_path__ + "static/media/expirence3.e12ca6f7a72e775bd140025e1f6c9795.svg";
export { ForwardRef as ReactComponent };